import _ from 'lodash';
import React from 'react';
import * as palette from '@mlc/mlc-palette';
import { Card, Col, Grid, Row } from '@mlc/web-ui-toolkit';
import moment from 'moment-timezone';
import TrackableAnchor from '../../common/Anchor/TrackableAnchor';
import footerTestIds from './FooterLinks.elements';
import * as Styled from './styled';

type Props = {
	links: Array<Link>;
	lastLoginDate: string;
	isSecure: boolean;
};

export const DATE_FORMAT = 'DD MMM YYYY hh:mm a';

//id footerWrapper is added here so that the NavigateToTopButton can find and dock on it when at the bottom of the screen
const FooterLinks: React.FunctionComponent<Props> = ({
	links,
	lastLoginDate,
	isSecure,
}) => {
	return (
		<Card
			backgroundColor={palette.mlcPartner}
			paddingBottom={6}
			paddingTop={6}
			id="footerWrapper"
			data-analytics-group="footer"
		>
			<Grid>
				<Row>
					<Col col={8}>
						<Styled.List>
							{_.map(links, (link, i) => (
								<Styled.ListElement key={i}>
									<TrackableAnchor
										analyticsId={`footer>${_.kebabCase(link.title)}`}
										data-id={footerTestIds.footerLinks}
										href={link.url}
										target={link.openInNewTab ? '_blank' : '_self'}
									>
										{link.title}
									</TrackableAnchor>
								</Styled.ListElement>
							))}
						</Styled.List>
					</Col>
					<Col col={4}>
						{isSecure ? (
							<Styled.LastLogin data-id={footerTestIds.lastLogin}>
								{`Last login: `}{' '}
								{lastLoginDate
									? moment
											.tz(lastLoginDate, 'Australia/Sydney')
											.local()
											.format(DATE_FORMAT)
									: 'unavailable'}
							</Styled.LastLogin>
						) : null}
					</Col>
				</Row>
			</Grid>
		</Card>
	);
};

export default FooterLinks;

interface Link {
	title: string;
	url: string;
	openInNewTab: boolean;
}
